<template>
    <clean-layout>
        <main role="main">
            <div class="container">
                <div class="row my-5">
                    <div class="col-12 col-md-10 col-lg-7 mx-auto text-center">
                        <h1 class="h2 font-poppins font-weight-light color-light-blue">
                            {{ Lang.get('employerdashboard::pages/auth/reset.title') }}
                        </h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-10 col-lg-7 mx-auto">
                        <div class="card shadow border-0 border-radius-16">
                            <AuthTabPanel>
                                <AuthTabPane
                                    :active="true"
                                    aria-label="employer-tab"
                                    id="employer"
                                >
                                    <p class="font-poppins font-weight-light color-dark-blue">
                                        {{ Lang.get('employerdashboard::pages/auth/reset.token_not_valid') }}
                                        <br/>
                                        <br/>

                                        <inertia-link class="font-poppins color-dark-blue d-block float-none float-sm-left mt-3 mt-sm-0 pt-2" :href="route('nl.employerdashboard.lost.password')">
                                            <u>{{ Lang.get('employerdashboard::shared.forgot_password_button') }}</u>
                                        </inertia-link>

                                        <inertia-link :href="route('nl.employerdashboard.home')" class="font-poppins color-dark-blue d-block float-none float-sm-right mt-3 mt-sm-0 pt-2"><u>
                                            {{ Lang.get('employerdashboard::shared.login_button') }}
                                        </u></inertia-link>
                                    </p>
                                </AuthTabPane>
                            </AuthTabPanel>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </clean-layout>
</template>

<script>
import CleanLayout from '@/Shared/CleanLayout'
import TextInput from "@/Shared/TextInput";
import AuthTabPanel from "./AuthTabPanel";
import AuthTabPane from "./AuthTabPane";

export default {
    metaInfo: { title: Lang.get('employerdashboard::pages/auth/reset.title') },
    components: {
        AuthTabPane,
        AuthTabPanel,
        TextInput,
        CleanLayout
    },
    props: {
        errors: Object,
    },
    data() {
        return {
            sending: false,
            form: {
                email: null,
            },
        }
    },
}
</script>
